import { ComponentDoc } from "../parser/types.js"
import { Component, ComponentProperty } from "../types.js"
import { mapToSupernovaProperty } from "./property.js"
import path from "node:path"

/**
 * Maps docgen results to supernova component
 */
export function mapToSupernovaComponent(component: ComponentDoc, entryPath: string): Component {
  return {
    exportName: component.exportName,
    exportType: component.exportType,
    description: component.description,
    tags: component.tags ?? null,
    componentPath: path.relative(entryPath, component.filePath),
    properties: Object.entries(component.props).reduce(
      (acc, [name, property]) => {
        if (property.name !== "key") {
          // skip react key prop
          acc[name] = mapToSupernovaProperty(property, entryPath)
        }

        return acc
      },
      {} as Record<string, ComponentProperty>,
    ),
  }
}
